<template>
	<div class="month-calendar">
		<span v-for="month of monthsKeys" :class="`month${month}`" :key="month">{{
			months[month].slice(0, 3)
		}}</span>
	</div>
</template>

<script>
import { months } from '@/assets/data';

const monthsKeys = Object.keys(months);
export default {
	data: () => ({
		months,
		monthsKeys,
	}),
};
</script>

<style lang="scss">
.month-calendar span {
	display: inline-block;
	background-color: var(--color-beige-light);
	width: 25%;
	font-family: monospace;
	text-align: center;
	float: left;
}

.month-calendar[data-month1] .month1 {
	background-color: var(--color-green);
}
.month-calendar[data-month2] .month2 {
	background-color: var(--color-green);
}
.month-calendar[data-month3] .month3 {
	background-color: var(--color-green);
}
.month-calendar[data-month4] .month4 {
	background-color: var(--color-green);
}
.month-calendar[data-month5] .month5 {
	background-color: var(--color-green);
}
.month-calendar[data-month6] .month6 {
	background-color: var(--color-green);
}
.month-calendar[data-month7] .month7 {
	background-color: var(--color-green);
}
.month-calendar[data-month8] .month8 {
	background-color: var(--color-green);
}
.month-calendar[data-month9] .month9 {
	background-color: var(--color-green);
}
.month-calendar[data-month10] .month10 {
	background-color: var(--color-green);
}
.month-calendar[data-month11] .month11 {
	background-color: var(--color-green);
}
.month-calendar[data-month12] .month12 {
	background-color: var(--color-green);
}
.month-calendar .month-now {
	outline-offset: -1px;
	outline: red dashed 1px;
}
</style>
